import React, { useState, useEffect } from "react";
import { getCustomerBillSummary } from "../../../api/endpoints/allReports.js";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar.js";
import { getAllPartySearch } from "../../../api/endpoints/search.js";
import { Button, Dropdown, Select, Menu } from "antd";
import Header from "../../header/header.jsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
const { Option } = Select;

const CustomerBillSummary = () => {
  const {user, access_token } = useSelector(authSelector);
  const [enteredOn, setEnteredOn] = useState("");
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [state, setState] = useState({
    parties: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    enteredOn: "",
    startingDate: "",
    reportType: "0",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const [itemsQueue, setItemsQueue] = useState([]);
 function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }
  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };
  const getAllData = async () => {
    const _parties = await getAllPartySearch(access_token);

    setState({
      ...state,
      parties: _parties,
    });
  };
  useEffect(() => {
    getAllData();
    getName()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const [loading, setLoading] = useState(false);
  const editHandler = async (e) => {
    if (!state.enteredOn) return message.error("Please type Ending date !");
    if (!state.startingDate)
      return message.error("Please type Starting date !");
    if (!state.partyId) return message.error("Please type Party Id !");
    let data = {
      startingDate: state.startingDate,
      enteredOn: state.enteredOn,
      partyId: state.partyId,
      reportType: Number(state.reportType),
    };
     try {
      setLoading(true); // disable button
    const results = await getCustomerBillSummary(data, access_token);
    console.log(results.data.length, "ressaaaaa");
    if (results.data.length === 0) {
      message.error("No Record Found in these date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            enteredOn: curr.enteredOn,
            partyId: Number(curr.partyId),
            vehicalId: Number(curr.vehicalId),
            regNumber: curr.regNumber,
            partyName: curr.partyName,
            couponNo: Number(curr.couponNo),
            itemCode: curr.itemCode,
            itemName: curr.itemName,
            saleRate: Number(curr.saleRate),
            quantity: Number(curr.quantity),
            amount: Number(curr.amount),
            debit: Number(curr.debit),
            credit: Number(curr.credit),
            siteId: curr.siteId,
            printOrder: curr.printOrder,
          },
        ];
      }, []);
      setItemsQueue(payload);
        generatePDF(payload);
    } else {
      message.error(results.message);
    }}
    catch (err) {
          message.error("Something went wrong!");
          console.error(err);
        } finally {
          setLoading(false); // re-enable button
        }
  };

  const clearState = () => {
    setItemsQueue([]);
  };
const generatePDF = (data) => {
  if (!data || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  const now = new Date();
  const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

  // ====== Header ======
  doc.setFontSize(8);
  doc.text(`Printed on: ${printDateTime}`, 200, 5, { align: "right" });
  doc.setFontSize(16);
  doc.text(siteName, 105, 11, { align: "center" });
  doc.setFontSize(12);
  doc.text(siteAddress, 105, 16, { align: "center" });
  doc.setFontSize(10);
  doc.text(
    `${state.partyName} From: ${formatDate(state.startingDate)} To ${formatDate(state.enteredOn)}`,
    105,
    20,
    { align: "center" }
  );

  // ====== Filter entries ======
  const filteredData = data.filter((r) => r.printOrder === 1);
  const lastPayableData = data.filter((r) => r.printOrder === 19);

  if (filteredData.length === 0 && lastPayableData.length === 0) {
    message.error("No records with printOrder = 1 or 19");
    return;
  }

  // ====== Sort entries date wise ======
  filteredData.sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn));

  // ====== Build Table Rows ======
  const tableRows = filteredData.map((r, i) => [
    i + 1, // SNO
    r.regNumber || "",
    r.vehicalId || "", // Vehicle
    r.couponNo?.toLocaleString() || "0", // NO OF COUPONS
    r.quantity.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    r.amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  ]);

  // ====== Totals ======
  const totalCoupons = filteredData.reduce((sum, r) => sum + (Number(r.couponNo) || 0), 0);
  const totalQty = filteredData.reduce((sum, r) => sum + (Number(r.quantity) || 0), 0);
  const totalAmount = filteredData.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);

  tableRows.push([
    "",
    "",
    "TOTAL",
    totalCoupons.toLocaleString(),
    totalQty.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  ]);

  // ====== Last Payable Bal + Total Payable (ONLY if siteId != 21) ======
  const siteId = data[0]?.siteId; // take siteId from first record
  if (siteId !== 21) {
    const lastPayableBal = lastPayableData.reduce(
      (sum, r) => sum + (Number(r.debit) || 0),
      0
    );

    if (lastPayableBal !== 0) {
      tableRows.push([
        "",
        "",
        "Last Payable Bal",
        "",
        "",
        lastPayableBal.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      ]);

      const totalPayable = totalAmount + lastPayableBal;
      tableRows.push([
        "",
        "",
        "Total Payable",
        "",
        "",
        totalPayable.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      ]);
    }
  }

  // ====== Render AutoTable ======
  autoTable(doc, {
    head: [["SNO", "REG NUMBER", "Vehicle", "NO OF COUPONS", "QUANTITY", "AMOUNT"]],
    body: tableRows,
    startY: 25,
    theme: "grid",
    margin: { left: 10, right: 10 },
    styles: {
      fontSize: 9,
      cellPadding: 1,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
      valign: "middle",
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 15 }, // SNO
      1: { halign: "center", cellWidth: 40 }, // Reg Number
      2: { halign: "center", cellWidth: 30 }, // Vehicle
      3: { halign: "center", cellWidth: 40 }, // No of Coupons
      4: { halign: "right", cellWidth: 30 },  // Quantity
      5: { halign: "right", cellWidth: 35 },  // Amount
    },
    didParseCell: (data) => {
      if (
        data.row.index === tableRows.length - 1 || // Last row
        data.row.raw[2] === "TOTAL" ||
        data.row.raw[2] === "Last Payable Bal" ||
        data.row.raw[2] === "Total Payable"
      ) {
        data.cell.styles.fontStyle = "bold";
      }
    },
  });

  // ====== Open PDF in new tab ======
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};

// const generatePDF = (data) => {
//   if (!data || data.length === 0) {
//     message.error("No data to generate report!");
//     return;
//   }

//   const doc = new jsPDF("p", "mm", "a4");
//   const now = new Date();
//   const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

//   // ====== Header ======
//   doc.setFontSize(8);
//   doc.text(`Printed on: ${printDateTime}`, 200, 5, { align: "right" });
//   doc.setFontSize(16);
//   doc.text(siteName, 105, 11, { align: "center" });
//   doc.setFontSize(12);
//   doc.text(siteAddress, 105, 16, { align: "center" });
//   doc.setFontSize(10);
//   doc.text(
//     `${state.partyName} From: ${formatDate(state.startingDate)} To ${formatDate(state.enteredOn)}`,
//     105,
//     20,
//     { align: "center" }
//   );

//   // ====== Filter entries ======
//   const filteredData = data.filter((r) => r.printOrder === 1);
//   const lastPayableData = data.filter((r) => r.printOrder === 19);



//   // ====== Build Table Rows ======
//   const tableRows = filteredData.map((r, i) => [
//     i + 1, // SNO
//     r.regNumber || "",
//     r.vehicalId || "", // Vehicle
//     r.couponNo?.toLocaleString() || "0", // NO OF COUPONS
//     r.quantity.toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }),
//     r.amount.toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }),
//   ]);

//   // ====== Totals ======
//   const totalCoupons = filteredData.reduce((sum, r) => sum + (Number(r.couponNo) || 0), 0);
//   const totalQty = filteredData.reduce((sum, r) => sum + (Number(r.quantity) || 0), 0);
//   const totalAmount = filteredData.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);

//   tableRows.push([
//     "",
//     "",
//     "TOTAL",
//     totalCoupons.toLocaleString(),
//     totalQty.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
//     totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
//   ]);

//   // ====== Last Payable Bal (printOrder 19) ======
//   const lastPayableBal = lastPayableData.reduce(
//     (sum, r) => sum + (Number(r.debit) || 0),
//     0
//   );

//   if (lastPayableBal !== 0) {
//     tableRows.push([
//       "",
//       "",
//       "Last Payable Bal",
//       "",
//       "",
//       lastPayableBal.toLocaleString(undefined, {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       }),
//     ]);

//     // ====== Total Payable ======
//     const totalPayable = totalAmount + lastPayableBal;
//     tableRows.push([
//       "",
//       "",
//       "Total Payable",
//       "",
//       "",
//       totalPayable.toLocaleString(undefined, {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       }),
//     ]);
//   }

//   // ====== Render AutoTable ======
//   autoTable(doc, {
//     head: [["SNO", "REG NUMBER", "Vehicle", "NO OF COUPONS", "QUANTITY", "AMOUNT"]],
//     body: tableRows,
//     startY: 25,
//     theme: "grid",
//     margin: { left: 10, right: 10 },
//     styles: {
//       fontSize: 9,
//       cellPadding: 1,
//       textColor: [0, 0, 0],
//       lineColor: [0, 0, 0],
//       lineWidth: 0.5,
//       valign: "middle",
//     },
//     headStyles: {
//       fillColor: [255, 255, 255],
//       textColor: [0, 0, 0],
//       fontStyle: "bold",
//       halign: "center",
//       valign: "middle",
//       lineColor: [0, 0, 0],
//       lineWidth: 0.5,
//     },
//     columnStyles: {
//       0: { halign: "center", cellWidth: 15 }, // SNO
//       1: { halign: "center", cellWidth: 40 }, // Reg Number
//       2: { halign: "center", cellWidth: 30 }, // Vehicle
//       3: { halign: "center", cellWidth: 40 }, // No of Coupons
//       4: { halign: "right", cellWidth: 30 },  // Quantity
//       5: { halign: "right", cellWidth: 35 },  // Amount
//     },
//     didParseCell: (data) => {
//       if (
//         data.row.index === tableRows.length - 1 || // Last row (Total Payable)
//         data.row.raw[2] === "TOTAL" ||
//         data.row.raw[2] === "Last Payable Bal"
//       ) {
//         data.cell.styles.fontStyle = "bold";
//       }
//     },
//   });

//   // ====== Open PDF in new tab ======
//   const pdfBlob = doc.output("blob");
//   const pdfUrl = URL.createObjectURL(pdfBlob);
//   window.open(pdfUrl);
// };



  return (
    <>
     
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <Header />
              <div className="flex justify-center mt-10">
                <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className=" text-white">Customer Bill Summary</h1>
                  </div>
                  <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                    <div>
                      <label className="text-white" for="fname">
                        Starting Date:
                      </label>
                      <input
                        type="date"
                        name="startingDate"
                        value={state.startingDate}
                        onChange={onChangeText}
                        className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                      />
                      <label className="text-white ml-2" for="fname">
                        Ending Date:
                      </label>
                      <input
                        type="date"
                        name="enteredOn"
                        value={state.enteredOn}
                        onChange={onChangeText}
                        className="bg-black dateInp text-white  inpTxt  mt-5 p-1 h-9 ml-3"
                      />
                    </div>
                    <div className="flex">
                  <div>
                    <label className="text-white ml-2 mr-2" for="fname">
                      Account:
                    </label>
                    <Select
                      showSearch
                      style={{
                        cursor: "pointer !important",
                        background: "red !important",
                      }}
                      name="partyId"
                      placeholder="A/C No."
                      // className=" custom-select ant-select bg-black text-white inpTxt mt-5 p-1 h-9 w-64"
                      className="ant-select-item-option-active bg-black text-white  mt-5 h-9  w-64"
                      optionFilterProp="children"
                      value={state.partyId || "A/C No."}
                      onChange={(e) => {
                        console.log("e", e);

                        const _party = state.parties.find(
                          (el) => el.partyId === e
                        );
                        if (_party) {
                          setState({
                            ...state,
                            partyId: e,
                            partyName: _party.PartyName,
                          });
                        } else {
                          setState({
                            ...state,
                            partyId: e,
                            partyName: "",
                          });
                        }
                      }}
                    >
                      <Option value={0}>None</Option>
                      {state.parties.map((el) => (
                        <Option
                          className="w-auto"
                          value={el.partyId}
                        >{`${el.partyId} - ${el.PartyName}`}</Option>
                      ))}
                    </Select>
                  </div>

                  <div>
                    <label className="text-white mt-5 ml-2 mr-2">
                      Report Type:
                    </label>
                    <Select
                      className="mt-5 ml-2 w-40"
                      value={state.reportType}
                      onChange={(value) =>
                        setState({ ...state, reportType: value })
                      }
                    >
                      <Option value="0">EnteredOn Wise</Option>
                      <Option value="1">Slip Date Wise</Option>
                    </Select>
                  </div>
                </div>
                    <div>
                     <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                      <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                        clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
       
    </>
  );
};

export default CustomerBillSummary;
